import { Component, Input, ViewChild } from '@angular/core';
import { ActionType, TextbookAction } from '@textbook-api-client';
import { Observable, of } from 'rxjs';
import { TextbookActionBase } from '../../internal/actions/@base/textbook-action-base.model';
import { GroupInfo } from '../../internal/models';

@Component({
  selector: 'txtb-textbook-actions',
  templateUrl: './textbook-actions.component.html',
  standalone: false,
})
export class TextbookActionsComponent {
  @Input() action!: TextbookAction;
  @Input() groupInfo!: GroupInfo;
  @ViewChild('actionHandlerComponent') actionHandlerComponent!: TextbookActionBase<TextbookAction>;
  actionType = ActionType;

  public canDeactivate(): Observable<boolean> {
    if (!this.actionHandlerComponent) {
      return of(true);
    }
    return this.actionHandlerComponent.canDeactivate();
  }
}
